import { useAuth } from '../auth/AuthContext';

/** Full library requires `profiles.subscription_active` (Stripe or manual in Dashboard). */
export function useSubscriptionAccess(): {
  hasFullAccess: boolean;
  profileLoading: boolean;
} {
  const { profile, profileLoading } = useAuth();
  const hasFullAccess = profile?.subscription_active === true;
  return { hasFullAccess, profileLoading };
}
